import { ApiUtil } from '@/shared/api';
import axios from 'axios';

export const createdApi = {
    /** 출제함 저장 */
    postSaveCreate: (param: API.SaveCreateBox.Req) => {
        return ApiUtil.post<API.SaveCreateBox.Res>('/integ/exam/save', param);
    },

    /** 출제함 - 수정하기 */
    updateCreated: (param: API.UpdateCreatedBox.Req) => {
        return ApiUtil.post<API.UpdateCreatedBox.Res>('/integ/exam/update', param);
    },

    /** 출제함 - 삭제하기 */
    deleteCreated: (param: API.DeleteCreatedBox.Req) => {
        return ApiUtil.post<API.DeleteCreatedBox.Res>('/integ/exam/delete', param);
    },

    /** 출제함 - 출제이력 교과서 목록 조회 */
    getCreatedHistList: (param: API.CreatedHistoryList.Req) => {
        return ApiUtil.get<API.CreatedHistoryList.Res>('/integ/exam/textbk/list', param);
    },

    /** 출제함 - 출제 목록 조회 */
    getCreatedBoxList: (param: API.CreatedBoxList.Req) => {
        return ApiUtil.get<API.CreatedBoxList.Res>('/integ/exam/list', param);
    },

    /** 출제함 상세조회 */
    getCreatedBoxDetail: (param: API.CreatedBoxDetail.Req) => {
        return ApiUtil.get<API.CreatedBoxDetail.Res>('/integ/exam/info', param);
    },

    /** 출제함 - 발행 이력 조회 */
    getCreatedBoxPublishedHistory: (param: API.CreatedBoxPublishedHistory.Req) => {
        return ApiUtil.get<API.CreatedBoxPublishedHistory.Res>('/integ/exam/hist', param);
    },

    /** 출제함 - 출제 정보표(이원목적 분류표) */
    getExamInfoTable: async (param: API.ExamInfoTable.Req) => {
        const response = await axios.get(
            import.meta.env.VITE_AIDT_URL_LCMSAPI + '/api/examInfo/articleMetaInfo',
            {
                params: {
                    articles: param.articles,
                    filename: param.filename,
                },
                responseType: 'blob',
            }
        );
        return response;
    },
    /** 출제함 - 출제 범위 조회 */
    postCreatedBoxRange: (param: API.CreatedBoxRange.Req) => {
        return axios.post<API.CreatedBoxRange.Res>(
            import.meta.env.VITE_AIDT_URL_LCMSAPI + '/api/vivasam/articleStudyMapInfo',
            param
        );
    },
};
